import React from 'react';
import { HStack } from '../../layouts/stack.layout';
import Container from '../container';
import Text from '../../typography/v2/text';

const styles = {
  container: 'items-end gap-1',
  text: 'font-text text-sm text-white inline-block',
  'action-text-wrapper': 'p-0 m-0 w-fit cursor-pointer',
};

type Props = {
  text: string;
  actionText: string;
  action: Function;
};

export default function FooterTextContainer({
  text,
  action,
  actionText,
}: Props) {
  return (
    <HStack extensions={styles.container}>
      <div className={styles.text}>{text}</div>
      <Container extensions={styles['action-text-wrapper']} onClick={action}>
        <Text variant="link">{actionText}</Text>
      </Container>
    </HStack>
  );
}
